import { Component, OnInit } from '@angular/core';
import { DebitoAutomaticoContrato } from '../modelo/debito-automatico-contrato';
import { SessaoService } from '../services/sessao.service';
import { AbstractComponent } from '../util/abstract.component';

declare var $: any;

@Component({
  selector: 'app-debito-automatico-contrato-conclusao',
  templateUrl: './debito-automatico-contrato-conclusao.component.html',
  styleUrls: ['./debito-automatico-contrato-conclusao.component.css']
})
export class DebitoAutomaticoContratoConclusaoComponent extends AbstractComponent implements OnInit {

  mensagem: string = "";
  cdMensagem: string = "";

  constructor(private sessaoService: SessaoService) {
    super(sessaoService);
  }

  ngOnInit() {
    //Scroll top
    window.scrollTo(0, 0);

    if (sessionStorage.getItem("debitoAutomaticoContrato")) {
      const debitoAutomaticoContrato: DebitoAutomaticoContrato = JSON.parse(sessionStorage.getItem("debitoAutomaticoContrato"));
      this.mensagem = debitoAutomaticoContrato.dsMsgemRetorno;
      this.cdMensagem = debitoAutomaticoContrato.cdMsgemRetorno;
    }

    // Close Menu Mobile
    var isMobile = window.matchMedia("only screen and (max-width: 760px)");
    $(".content").click(function() {
      if (isMobile.matches) {
        $(".page").removeClass("toggled");
      }
    });
  }

}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/debito-automatico/debito-automatico-contrato-conclusao.component.ts